export default __webpack_public_path__ + "b0c5fa27255d92a60b3974378c703192.png";